import { useQuery } from 'react-query'
import { fetchToken } from '../api'
import { FetchTokenResponse } from '../types'

export default function useToken({ tokenUuid }: { tokenUuid?: string }) {
  const { data, refetch, isFetching } = useQuery<FetchTokenResponse>(
    ['token', tokenUuid],
    () => {
      return fetchToken(tokenUuid)
    }
  )

  return {
    token: data?.data?.token,
    metadata: data?.data?.metadata,
    refetch,
    isFetching
  }
}
